<template>
	<main-page :user="user" hide-footer>
		<template v-slot:title>
			INNOVATOR PORTFOLIO
		</template>

		<div class="container">
			<h1 class="si-font mt-5 pb-0">Welcome!</h1>
			<h3 class="text-muted mt-2">{{ fs.displayName(user.name) }}</h3>
			<div class="row splash-buttons justify-content-center">
				<div v-if="showProfile && (this.context && !this.context.is_contest)" class="col-6 col-sm-4 splash-button-zone">
					<a class="splash-button-link" @click="goToProfile">
						<img class="splash-button" src="@/assets/images/Innovator_Profile.png" />
					</a>
				</div>
				<div v-if="showPitch && (this.context && !this.context.is_contest)" class="col-6 col-sm-4 splash-button-zone">
					<a class="splash-button-link" href="#/pitch_entry">
						<img class="splash-button" src="@/assets/images/Pitches.png" />
					</a>
				</div>
				<div v-if="this.context && this.context.is_contest" class="col-6 col-sm-4 splash-button-zone">
					<a class="splash-button-link" href="#/pitch_entry">
						<img class="splash-button" src="@/assets/images/Pitch_Contest_Icon.png" />
					</a>
				</div>
				<div v-if="showCanvas && (this.context && !this.context.is_contest)" class="col-6 col-sm-4 splash-button-zone">
					<a class="splash-button-link" href="#/canvas">
						<img class="splash-button" src="@/assets/images/Innovation_Canvas.png" />
					</a>
				</div>
				<div v-if="showTVR && (this.context && !this.context.is_contest)" class="col-6 col-sm-4 splash-button-zone">
					<a class="splash-button-link" href="#/tvr">
						<img class="splash-button" src="@/assets/images/TVR.png" />
					</a>
				</div>
				<div v-if="showPrototype" class="col-6 col-sm-4 splash-button-zone">
					<a class="splash-button-link" href="#/prototype_entry">
						<img class="splash-button" src="@/assets/images/Prototype.png" />
					</a>
				</div>
				<div v-if="showExam && (this.context && !this.context.is_contest)" class="col-6 col-sm-4 splash-button-zone">
					<a class="splash-button-link" href="#/exam">
						<img class="splash-button" src="@/assets/images/Proficiency_Exam.png" />
					</a>
				</div>
			</div>
		</div>
		<template v-slot:footer>
			<div class="col-6 text-right">
				<a
					v-if="user.role=='TEACHER'"
					class="btn btn-si-secondary"
					href="#/class_details">Back</a>
				<a v-else class="btn btn-si-secondary" href="#/classes">Back</a>
			</div>
		</template>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import ProgramService from "@/services/ProgramService";
import SectionService from "@/services/SectionService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";

export default {
	name: "Portfolio",

	props: ["user"],

	components: { MainPage },

	data() {
		return {
			fs: fs,
			program: null,
			context: null,
		};
	},

	created() {
		this.loadData();
	},

	computed: {
		showProfile() {
			if (this.user.role == "PARTNER") {
				return false;
			}
			if (!this.program) {
				return true;
			}

			return this.program.profile_config && this.program.profile_config.questions.length > 0;

		},

		showPitch() {
			if (!this.program) {
				return true;
			}

			if (this.program.pitch_config && this.program.pitch_config.rubric) {
				if (this.program.pitch_config.rubric.categories && this.program.pitch_config.rubric.categories.length > 0) {
					return true
				}
			}
			if (this.program.contest_config && this.program.contest_config.rubric) {
				if (this.program.contest_config.rubric.categories && this.program.contest_config.rubric.categories.length > 0) {
					return true
				}
			}
			return false
		},

		showPrototype() {
			if (!this.program) {
				return true;
			}

			if (!this.program.prototype_config) {
				return false;
			}

			return (this.program.prototype_config.upload_instructions &&
                this.program.prototype_config.upload_instructions.length > 0) ||
              (this.program.prototype_config.feedback_instructions &&
                this.program.prototype_config.feedback_instructions.length > 0)
		},

		showCanvas() {
			
			if (!this.program) {
				return true;
			}

			return this.program.show_canvas;
		},

		showTVR() {
			if (!this.program) {
				return true;
			}

			return this.program.tvr_config && this.program.tvr_config.rubric.categories.length > 0;
		},

		showExam() {
			if (!this.program) {
				return true;
			}

			return this.program.exam_config;
		},
	},

	methods: {
		loadData() {
			BB.props({
				program: ProgramService.getContextProgram(),
				context: SectionService.getContextPrefilled()
			})
				.then((r) => {
					this.program = r.program.data;
					this.context = r.context.data;
				})
				.catch((e) => {
					console.error(e);
					Notie.error("Failed to load program", e);
				});
			
		},

		goToProfile() {
			if (this.user.role == "STUDENT") {
				this.$router.push("/profile_entry");
			} else {
				this.$router.push("/profile_results");
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.splash-button-zone {
	padding: 3rem;
}
.splash-button-link > img {
	transition: transform 0.15s ease-in-out;
}
.splash-button-link:hover > img {
	transform: scale(1.05);
}
.splash-button {
	width: 100%;
}
</style>
